<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../assets/footer-logo.webp" alt="" />
        </div>
        <div class="contact-list">
            <div class="contact" v-for="(item, index) in list" :key="index">
                <img class="item-icon" :src="item.icon" alt="">
                <div class="item-text">{{ item.title }}</div>
            </div>
        </div>
        <div class="bottom">
            © 2026 HARUTOJA CREATION SERVICES PRIVATE LIMITED. All rights reserved.
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        title: '+91 9831338025',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: `26-27-a Third Floor, Office No-1, Block-h, New Delhi, New Delhi, New Delhi, Delhi, India, 110092, DELHI`,
        icon: require('../assets/footer-icon2.webp')
    },
    {
        title: 'support@harutoja-creation.com',
        icon: require('../assets/footer-icon3.webp')
    },
]
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    height: auto;
    background: #000B38;
    padding: 0 230px;
    box-sizing: border-box;

    .logo-box {
        padding-top: 63px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 41px;

        .logo {
            width: 273px;
            height: 43px;
            object-fit: cover;
            margin-bottom: 64px;
        }
    }

    .contact-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 35px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.31);

        .contact {
            display: flex;
            justify-content: start;
            align-items: center;

            .item-icon {
                width: 27px;
                height: 27px;
                object-fit: contain;
                margin-right: 11px;
            }

            .item-text {
                max-width: 215px;
                font-weight: 500;
                font-size: 11px;
                color: #DCDCDC;
                line-height: 16px;
            }
        }
    }

    .bottom {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 18px;
        padding: 15px 0;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>